module.exports = __webpack_public_path__ + "static/media/insta.070bdf86.svg";